import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@context/AuthContext';
import Spinner from '@components/ui/Spinner';
import { unauthenticatedEntryPath } from '@utils/authEntryPaths';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to={unauthenticatedEntryPath()} state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
